import _ from 'lodash'

export const camelCaseString = str => _.camelCase(str)

export const stringToBoolean = string =>
  string === 'false' || string === 'undefined' || string === 'null' || string === '0' || string === '' ? false : !!string
